import React from 'react';
import './testimonial.css';

function TestiBlock({content:{id,name,designation,description,img}}) {

    return (
        // <SwiperSlide>
            <div className="testimonial-block">
                <div className="testimonial-img-container">
                    <div className="testimonial-mini-img-container">
                        <img src={img} alt=""/>
                    </div>   
                </div>

                <div className="testimonial-content">
                    <p className="testimonial-para">{description}</p>
                    <h5 className="testimonial-name">{name}</h5>
                    <h4 className="testimonial-designation">{designation}</h4>
                </div>
            </div>
        // </SwiperSlide>
    )
}

export default TestiBlock
